<template>
  <el-dialog
    width="720px"
    :title="`批量编辑点云切片`"
    :visible.sync="modelValue"
    custom-class="relic-detail-census-edit relic-dialog"
    :before-close="handleClose"
  >
    <!-- 图片列表 -->
    <ul class="edit-imgs">
      <li
        v-for="img in imgList"
        :key="img.relicPointcloudPhotoAutoIncrementId"
        class="edit-imgs__item"
      >
        <img :src="img.url" alt="" />
        <!-- modal -->
        <div class="edit-imgs__modal flex-align">
          <el-button class="edit-imgs__action showMap" type="primary">
            地图显示
          </el-button>
          <el-button
            class="edit-imgs__action"
            type="primary"
            @click="openConfrim(img.relicPointcloudPhotoAutoIncrementId)"
          >
            删除图片
          </el-button>
        </div>
      </li>
    </ul>

    <!-- footer -->
    <!-- <template v-slot:footer class="edit-footer">
      <el-button
        plain
        type="primary"
        class="edit-footer__btn edit-footer__btn--cancel"
      >
        取消
      </el-button>
      <el-button
        type="primary"
        class="edit-footer__btn edit-footer__btn--confirm"
      >
        保存
      </el-button>
    </template> -->
  </el-dialog>
</template>

<script>
import { modelMixin } from '../../assets/js/mixins/model';

export default {
  name: 'RelicDetailCensusEdit',
  mixins: [modelMixin],
  props: {
    imgList: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('onCloseUpdatePhoto', this.imgType);
      done();
    },
    /**
     * 删除确认弹窗回掉
     */
    openConfrim(photoId) {
      this.$confirm('确定要删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'attribute-delete-msgbox',
        center: true
      })
        .then(() => {
          this.$emit('onConfirmDeletePhoto', photoId);
        })
        .catch(() => {
          this.$prompt('已取消删除');
        });
    }
  }
};
</script>

<style lang="scss">
.relic-detail-census-edit {
  .el-dialog {
    &__header {
      padding-top: 24px;
      padding-left: 32px;
    }
    &__body {
      padding: 20px 21px;
      height: 820px;
    }
    &__footer {
      padding: 20px;
      padding-right: 28px;
    }
  }
  .edit {
    &-footer {
      &__btn {
        margin-left: 40px;
        width: 70px;
        height: 40px;
        border-radius: 5px;
      }
    }
    &-imgs {
      display: flex;
      flex-wrap: wrap;
      max-height: 720px;
      overflow-y: auto;
      &__item {
        img {
          width: 200px;
          height: 143px;
        }
        position: relative;
        margin-right: 30px;
        margin-bottom: 30px;
        width: 200px;
        height: 143px;
        background-color: #f2f2f2;
        border: 1px solid #000;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      &__modal {
        position: absolute;
        justify-content: space-between;
        width: 100%;
        left: 0;
        bottom: 0;
      }
      &__img {
      }
      &__action {
        flex: 1;
        height: 43px;
        border-radius: 0;
        background-color: rgba(0, 0, 0, 0.3);
        & + .el-button {
          margin-left: 3px;
        }
      }
      .showMap {
        background-color: $color-primary;
      }
    }
  }
}
.attribute-delete-msgbox {
  width: 300px;
  height: 170px;
  .el-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-around;
    width: 200px;
    margin: 0 auto;
    margin-top: 20px;
    button:nth-child(2) {
      margin-left: 0;
    }
  }
  .el-button {
    background-color: $color-primary;
    color: #fff;
  }
}
</style>
